import React from 'react';
import PropTypes from 'prop-types';
import { useLocation, useNavigate } from 'react-router-dom';
import { DragDropContext } from '@hello-pangea/dnd';

import api from 'utils/api';
import { IssueStatusKenshin } from 'shared/constants/kenshin/issues';
import localData from 'utils/localData';

import List from './KenshinList';
import { Lists } from './Styles';
import { HandleIssueDrop } from './utils';
import { ProjectProptypes } from 'shared/propTypes/projectType';
import { USER_COMMENT } from 'shared/constants/comment';
import { KENSHIN_API } from 'shared/constants/apis';
import { ALERT_MODAL_INFO } from 'views/Kanban/constants';
import { USER_DATA } from 'shared/constants/users';

const propTypes = {
  project: PropTypes.shape(ProjectProptypes).isRequired,
  fetchProject: PropTypes.func.isRequired,
  updateLocalProjectIssues: PropTypes.func.isRequired,
  setAlertModalOpen: PropTypes.func.isRequired,
  setAlertModalInfo: PropTypes.func.isRequired,
  setConfirmModalOpen: PropTypes.func.isRequired,
  setConfirmModalUpdateData: PropTypes.func.isRequired,
  setConfirmModalInfo: PropTypes.func.isRequired,
  updateLocalProjectWithMoreDoneIssues: PropTypes.func.isRequired,
};

const ProjectBoardLists = ({
  project,
  fetchProject,
  updateLocalProjectIssues,
  setAlertModalOpen,
  setAlertModalInfo,
  setConfirmModalOpen,
  setConfirmModalUpdateData,
  setConfirmModalInfo,
  updateLocalProjectWithMoreDoneIssues,
}) => {
  const currentUserId = localData.get(USER_COMMENT.USER_ID);
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const updateIssue = (issueId, destination, project, listPosition) => {
    api.optimisticUpdate(
      `${KENSHIN_API.ISSUES}/single/${issueId}`,
      {
        updatedFields: {
          progress: destination.droppableId,
          listPosition: listPosition,
        },
        currentFields: project.issues.find(({ id }) => id === issueId),
        setLocalData: (fields) => updateLocalProjectIssues(issueId, fields),
      },
      {
        params: {
          organizationId: localData.get(USER_DATA.CURRENT_ORGANIZATION_ID),
          username: localData.get(USER_DATA.USERNAME),
          userId: currentUserId,
        },
        baseURL: import.meta.env.VITE_KENSHIN_API_URL,
      }
    );
  };

  const goToIssueDetails = (issueId) => {
    navigate(`${pathname}/issues/${issueId}`, {
      state: { trigger: 'byDrop' },
    });
  };

  const showInvalidDestinationAlert = () => {
    // invalid destination
    setAlertModalInfo(ALERT_MODAL_INFO.INVALID_DESTINATION);
    setAlertModalOpen(true);
  };

  const handleDrop = ({ draggableId, destination, source }) => {
    HandleIssueDrop(
      draggableId,
      destination,
      source,
      updateIssue,
      project,
      goToIssueDetails,
      showInvalidDestinationAlert,
      setConfirmModalInfo,
      setConfirmModalOpen,
      setConfirmModalUpdateData
    );
  };

  return (
    <DragDropContext onDragEnd={handleDrop}>
      <Lists>
        {Object.values(IssueStatusKenshin).map((progress, index) => (
          <List
            key={index}
            progress={progress}
            project={project}
            fetchProject={fetchProject}
            currentUserId={currentUserId}
            updateLocalProjectWithMoreDoneIssues={
              updateLocalProjectWithMoreDoneIssues
            }
          />
        ))}
      </Lists>
    </DragDropContext>
  );
};

ProjectBoardLists.propTypes = propTypes;

export default ProjectBoardLists;
